// extracted by mini-css-extract-plugin
module.exports = {"label":"style_label__2yePJ","avatar":"style_avatar__2AEM3","container":"style_container__3rZpB"};